import LandingHeader from "../../components/layout/landingHeader";
import LandingFooter from "../../components/layout/landingFooter";
import Method from "../../assets/images/Method.png";
import Architecture from "../../assets/images/Architecture.png";
import cloudRight from "../../assets/vector/Vector-4.png";
import cloudFloat from "../../assets/vector/Vector-4.svg";
import cloudRight9 from "../../assets/vector/Vector-9.png";
 
const RobustnessPage = () => {
  return (
    <>
      <LandingHeader />

      {/* ===== HERO ===== */}
      <section className="hero-tech-mini hero-ryse-title arch-section">
        <div className="arch-bg">
 
          <img src={cloudRight} className="arch-cloud arch-cloud--right" alt="" />
        </div>

        <div className="hero-tech">
          <div className="hero-ryse__content mw-900">
            <h1 className="hero-ryse__headline w-none">
              Robustness of Ryse Methodology
            </h1>
          </div>
        </div>
      </section>

      <section className="secure-arch arch-section vp-20  p-40-20" style={{ flexDirection: "column" }}>
        <div className="arch-bg">
           <img src={cloudRight9} className="arch-cloud arch-cloud--right" alt="" />
        </div>

        <div className="tech-arch__frame">
          <div className="secure-arch__inner">

            <div className="secure-arch__content">
              <h2 className="content__title">Method</h2>

              <p className="content__body">
                Because of alternative investments, the platform measures both
                linear and non-linear behavior of all the asset using 5
                different distributions (Most risk management platforms are
                based on Normal distribution analytics).
              </p>
            </div>

            <div  className="img-left">
              <div className="secure-arch__image-wrapper">
                <img src={Method} alt="" className="secure-arch__image" />
              </div>
            </div>

          </div>
        </div>

        <div className="product-card bg-dark">
          <h3 className="text-square b">Distributions Used:</h3>

          <h3 className="text-square b">Parametric</h3>
          <ul>
            <li className="text-square">Gaussian (Normal)</li>
            <li className="text-square">t – Distribution</li>
          </ul>

          <h3 className="text-square b">Archimedean</h3>
          <ul>
            <li className="text-square">Gumbel</li>
            <li className="text-square">Clayton & Frank</li>
          </ul>

          <b className="text-square b">Additional Capability</b>
          <p className="text-square">
            Causality-based analytics to develop forward-looking relationships
            between the market and the portfolio...
          </p>
        </div>
      </section>

      {/* ===== ARCHITECTURE ===== */}
      <section className="secure-arch arch-section vp-20  p-40-20" style={{ flexDirection: "column" }}>
        <div className="arch-bg">
          <img src={cloudFloat} className="arch-cloud arch-cloud--left" alt="" />
          <img src={cloudFloat} className="arch-cloud arch-cloud--right" alt="" />
        </div>

        <div className="tech-arch__frame">
          <div className="secure-arch__inner">

            <div className="secure-arch__visual">
              <div className="secure-arch__image-wrapper">
                <img src={Architecture} alt="" className="secure-arch__image" />
              </div>
            </div>

            <div className="secure-arch__content">
              <h2 className="content__title">Architecture</h2>

              <p className="content__body">
                Platform architecture allows analytics to be done on-demand...
              </p>

              <p className="content__body">
                Developed in-house AI tools that work as Agents to do the work
                of a risk management team...
              </p>

              <p className="content__body">
                Interaction with many other AI models available in the market
                (LLMs).
              </p>
            </div>

          </div>
        </div>

        <div className="product-card bg-dark">
          <h3 className="text-square b">Portfolio analytics</h3>
          <p className="text-square">
            Comprehensive reporting supported with AI or standalone reporting.
          </p>
        </div>
      </section>

      <LandingFooter />
    </>
  );
};

export default RobustnessPage;
